import Timer from "./Timer";
import { useDispatch } from "react-redux";
import { modalActions } from "../../storage/modals";

const DayDeals = (props) => {
  const dispatch = useDispatch();

  const addToCart = (id) => {
    dispatch(modalActions.showAddToCartModal(id));
  };

  return (
    <section className="temporary temporary_day">
      <div className="container">
        <div className="common-title">
          <h2 className="common-title__h2">
            <span>Дневное</span> предложение
          </h2>
          <div className="common-title__subtitle common-title__subtitle_flex">
            <p className="common-title-subtitle">
              наборы доступны до конца дня, обновление через
            </p>
            <Timer deadline={new Date().setHours(23, 59, 59)} />
          </div>
        </div>
        <div className="products">
          {props.products.map((item) => {
            let discount = 0;

            if (item.old_price > item.price) {
              discount = (
                ((item.old_price - item.price) * 100) /
                item.old_price
              ).toFixed(0);
            }

            return (
              <div
                className={
                  item.popular === "1" ? "product product_popular" : "product"
                }
                key={item.id}
              >
                {discount > 0 && (
                  <span className="product-discount">-{discount}%</span>
                )}
                <div className="product__half product__half_top">
                  <div className="product-top">
                    <img
                      src={
                        item.icon
                          ? item.icon
                          : "/assets/images/dummy_product.png"
                      }
                      className="product-icon"
                      alt={item.name}
                    />
                    {item.popular === "1" && (
                      <span className="product-popular-label">Популярный</span>
                    )}
                  </div>
                  <div className="product-bottom">
                    <h5 className="product-title">{item.name}</h5>
                    <div className="product-price">
                      <span className="product-price__value">
                        {item.price} &#8381;
                      </span>
                      <div className="product-price__attrs">
                        {item.old_price > item.price && (
                          <span className="product-price-old">
                            {item.old_price} &#8381;
                          </span>
                        )}
                        <span
                          className="product-duration"
                          style={
                            item.price > item.old_price
                              ? { marginTop: "10px" }
                              : undefined
                          }
                        >
                          {item.period}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="product__half product__half_bottom">
                  <button
                    type="button"
                    className="product-buy"
                    onClick={() => {
                      addToCart(item.id);
                    }}
                  >
                    Купить
                  </button>
                </div>
              </div>
            );
          })}
          {/* <div className="product product_off">
            <div className="product__half product__half_top">
              <div className="product-top">
                <img
                  src="/assets/images/off_product.png"
                  className="product-icon"
                  alt="Top secret"
                />
              </div>
              <div className="product-bottom">
                <h5 className="product-title">Top secret</h5>
                <div className="product-price">
                  <span className="product-price__value">
                  Скоро в продаже
                  </span>
                </div>
              </div>
            </div>
            <div className="product__half product__half_bottom">
              <button type="button" className="product-buy" disabled={true}>
                Недоступно
              </button>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default DayDeals;
